import { useKeycloak } from "@react-keycloak/web";
import React, { PropsWithChildren } from "react";

interface RoleComponentProps {
  realmRoles?: string | string[];
  resourceRoles?: string | string[];
  matchAll?: boolean;
}

export const RoleComponent: React.FC<PropsWithChildren<RoleComponentProps>> = ({
  realmRoles,
  resourceRoles,
  matchAll = false,
  children,
}) => {
  const { keycloak } = useKeycloak();

  const hasRoles = (
    roles: string | string[],
    validationCallback: (roles: string) => boolean,
  ) => {
    if (!roles) return true;

    if (typeof roles === "string") {
      return validationCallback(roles);
    }

    if (matchAll) {
      return roles.every((role) => validationCallback(role));
    }

    return roles.some((role) => validationCallback(role));
  };

  const hasRealmRoles = hasRoles(realmRoles, (role) =>
    keycloak.hasRealmRole(role),
  );
  const hasResourceRoles = hasRoles(resourceRoles, (role) =>
    keycloak.hasResourceRole(role, "uverify"),
  );

  if (hasRealmRoles && hasResourceRoles) {
    return <>{children}</>;
  }

  return null;
};
